module.exports = __webpack_public_path__ + "img/avatar-s-9.ec990ac1.png";